<template>
  <div id="home">
    <div id="content">
      <div class="row center-xs middle-xs">
        <div class="col-xs-12">
          <img
            class="malden-logo--big"
            src="@/assets/malden-logo-full.svg"
            alt="Malden Catholic Logo">
        </div>
      </div>
      <div class="row center-xs middle-xs">
        <div class="col-xs-12">
          <h1>Two Exceptional Schools<br>One Tradition of Excellence</h1>

          <p>Thank you for visiting our Fall Open House reservation page! As you RSVP, we’d like to ask a few simple questions about your child’s interests. This will help us customize your visit, and deliver the information that matters most to you and your child as you consider Malden Catholic.</p>
        </div>
      </div>
      <div class="row center-xs middle-xs">
        <div class="col-xs-12">
          <router-link
            to="/about-you"
            class="btn">Get Started</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    nextPage() {
      this.$router.push('/about-you');
    },
  },
};
</script>

<style lang="scss">
  #home {
    margin: 0 auto;
    padding: 0 1rem;
    color: white;

    .reg-close {
      text-align: center;
      color: #FAB613;
      padding-top: 40px;
      padding-bottom: 40px;
      border: 2px dashed #FAB613;
    }

    img {
      max-width: 100%;
    }

    h1 {
      font-size: 1.5rem;
      margin-bottom: 3rem;
    }

    h2 {
      font-size: 1.25rem;
      margin-bottom: 3rem;
      text-align: left;
    }

    p {
      text-align: left;
      font-size: 1rem;
      line-height: 1.4;
      margin-bottom: 3rem;
    }
  }

  @media (min-width: 47rem){
    #home {
      padding: 0;

      h1 {
        font-size: 2rem;
      }

      h2 {
        font-size: 1.5rem;
      }

      p {
        font-size: 1.25rem;
      }
    }
  }
</style>
